import { CheckOnboardingInfoState } from './checkOnboardingInfo.types'

const initialState: CheckOnboardingInfoState = {
  loading: false,
  error: null,
  success: null
  // Initialize any additional state properties here
}

export default initialState
